import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export const Testimonials = () => {
  const testimonials = [
    {
      name: "Matias Delgado",
      text: "Superior roofing solutions are provided by Safeway Roofing & Chimney. Their expert and long-lasting service, which ranges from repairs to complete replacements, gives homeowners peace of mind.",
      rating: 5
    },
    {
      name: "Susilawati",
      text: "Safeway Roofing & Chimney provided excellent service. Jimmy and his team were very professional, quick, and thorough when repairing our roof. I couldn't be happier with their work!",
      rating: 5
    },
    {
      name: "Hartadi Prayudha",
      text: "The roof repair from Safeway Roofing & Chimney was quick and professional. Jimmy and his team worked efficiently, and the results were outstanding. I would definitely recommend them!",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-blue-50/50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
            What Our Clients Say
          </h2>
          <p className="text-xl text-muted-foreground">
            Trusted by Homeowners Across the Community!
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-0 shadow-lg bg-card/95 backdrop-blur-sm hover:shadow-xl transition-all duration-300">
              <CardContent className="p-8">
                {/* Stars */}
                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                
                {/* Google Logo */}
                <div className="flex items-center space-x-2 mb-4">
                  <div className="w-6 h-6 bg-blue-600 rounded flex items-center justify-center">
                    <span className="text-white text-xs font-bold">G</span>
                  </div>
                  <span className="text-sm text-muted-foreground">Google Review</span>
                </div>

                {/* Review Text */}
                <p className="text-muted-foreground leading-relaxed mb-6">
                  "{testimonial.text}"
                </p>

                {/* Name */}
                <div className="font-semibold text-foreground">
                  {testimonial.name}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="grid md:grid-cols-3 gap-8 mt-16 text-center">
          <div className="space-y-2">
            <h3 className="text-2xl font-bold text-primary">20+</h3>
            <p className="text-muted-foreground">Years of Trusted Service</p>
          </div>
          <div className="space-y-2">
            <h3 className="text-2xl font-bold text-primary">24/7</h3>
            <p className="text-muted-foreground">Emergency Repairs</p>
          </div>
          <div className="space-y-2">
            <h3 className="text-2xl font-bold text-primary">Same-Day</h3>
            <p className="text-muted-foreground">Service Available</p>
          </div>
        </div>
      </div>
    </section>
  );
};